import React from "react";
import CookieContainer$ from "@deosite/components-new/CookieContainer";
import CookieNotice from "../CookieNotice";
import dynamic from "next/dynamic";
const CookieContainerNew = props => {
  const propsExt = {
    ...props,
    cookieNotice: <CookieNotice />,
    cookiesPanel: dynamic(() => import("../CookiesPanel"))
  };
  return <CookieContainer$ {...propsExt} />;
};

export default CookieContainerNew;
